module.exports = __webpack_public_path__ + "img/6.ee0b0a83.png";